module.exports = __webpack_public_path__ + "img/MyTicket.5a906980.svg";